<template>
  <div style="background-color: #323232; height: 100%;">
    <b-overlay style="height: 100%;" :show="showDownloadLoading" rounded="sm">
      <div class="header">
        <div class="title-container">
          <h3>Feuilles de temps</h3>
        </div>
        <div class="button_container">
          <b-button variant="success" @click="initExport()">Exporter les heures</b-button>
        </div>
      </div>
      <div class="employees-container">
        <div class="employees-list-header">
          <input
            style="background-color: transparent; color: #fff; width: 70%; height: 30px; font-size: large; outline: none; border: none;"
            type="text" v-model="input" placeholder="Recherche . . ." />
        </div>
        <div class="employees-list-body">
          <b-row>
            <b-col v-for="employee in displayedEmployees" :key="employee.id" class="mb-4" cols="12" md="3" lg="4">
              <b-card id="employee-card" class="text-center employee-card"
                @click="navigateToEmployeeDetails(employee.id)" style="cursor: pointer;">
                <b-avatar class="mb-2" size="4rem" variant="default"><i class="fas fa-user"></i></b-avatar>
                <h5 class="name">{{ employee.firstname }} {{ employee.lastname }}</h5>
                <p class="subtitle">{{ employee.job ? employee.job : 'Aucun poste défini' }}</p>
              </b-card>
            </b-col>
          </b-row>
        </div>
      </div>
      <div v-if="showDownloadLoading" class="loading-overlay">
        <b-card class="text-center">
          <b-spinner variant="success" small></b-spinner>
          <h3 class="mt-2">Téléchargement en cours...</h3>
        </b-card>
      </div>
    </b-overlay>
  </div>
</template>


<script>
import script_pointage from '../../../script/script_pointage'

function initValue() {
  return {
    employees: [],
    thirdpartyId: '',
  }
}

export default {
  data() {
    return {
      employees: [],
      thirdpartyId: '',
      thirdparty: {},
      user: {},
      showDownloadLoading: false,
      tableFields: [
        {
          key: 'employeeFullName',
          label: 'Employés',
          sortable: true,
        },
      ],
      input: '',
      PointageEvents: [],
    }
  },
  computed: {
    filteredEmployees() {
      const normalizeString = (str) => str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLocaleLowerCase();
      const searchInput = normalizeString(this.input);

      return this.employees.filter(employee => {
        const fullName = `${employee.firstname} ${employee.lastname}`;
        return normalizeString(fullName).includes(searchInput);
      });
    },
    displayedEmployees() {
      const employees = this.input ? this.filteredEmployees : this.employees;
      return employees.sort((a, b) => {
        const nameA = `${a.firstname}`.toUpperCase(); // Vous pouvez changer cela pour trier par prénom ou nom de famille
        const nameB = `${b.firstname}`.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    }
  },
  async created() {
    this.user = await this.getUserById(localStorage.getItem('userid'));
    console.log(this.user);
    this.thirdpartyId = await this.getCookie('thirdpartyId');
    this.thirdparty = await this.getThirdpartyWithId(this.thirdpartyId);

    this.employees = await this.getAllUsers();
  },
  methods: {
    getAllUsers: script_pointage.getUsers,
    exportMensualHours: script_pointage.exportRapportMensuel,
    getThirdpartyWithId: script_pointage.getThirdpartyById,
    getUserById: script_pointage.getUserById,

    navigateToEmployeeDetails(id) {
      this.$router.push({ name: 'details-employes', params: { id: id } });
    },

    async getCookie(cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },

    async initExport() {
      this.showDownloadLoading = true;

      const client = await this.initClient();

      const minLoadingTime = new Promise(resolve => setTimeout(resolve, 1500));

      await Promise.all([this.exportMensualHours(client), minLoadingTime]);

      this.showDownloadLoading = false;
    },

    async initClient() {
      var client = {
        socname: this.thirdparty.name,
        socid: this.thirdparty.id,
        dolibarr_url: await this.getCookie('dolibarr_url'),
        api_key: this.thirdparty.array_options.options_api_key_aloha_clock_notification,
        notifyMembers: {
          nom: this.user.lastname,
          prenom: this.user.firstname,
          email: this.user.email,
        }
      };

      return client;
    },

    async displayPointageEvents() {
      this.loading = true;  // Commencer le chargement

      let pointageEvents = await this.getPointageEvents();
      pointageEvents = pointageEvents.slice(0, config.nbPointageEventDisplayed);

      pointageEvents.sort((a, b) => {
        return new Date(b.datec) - new Date(a.datec);
      });

      const updatedEvents = await Promise.all(pointageEvents.map(async (event) => {
        if (event.userownerid) {
          let user = await this.getUsersById(event.userownerid);

          event.userFirstName = user.firstname;
          event.userLastName = user.lastname;
          event.datec = this.formatDate(event.datec * 1000);
          event.datem = this.formatDate(event.datem * 1000);
        }
        return event;
      }));

      this.PointageEvents = updatedEvents;
      console.log(this.PointageEvents);

      this.loading = false;  // Terminer le chargement
    },
  }
}

</script>

<style scoped>
input:focus {
  outline: none;
  border-bottom: 5px solid #b9b9b9;
}

.name {
  font-weight: bold;
}

.subtitle {
  color: lightgrey;
}

.loading-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1050;
  /* Ajustez en fonction de vos besoins */
  display: flex;
  justify-content: center;
  align-items: center;
}

.employees-container {
  height: calc(100%-60px);
  width: 100%;
  background-color: #3f3f3f;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.employees-list-header {
  box-shadow: 1px 9px 15px -1px #2e2e2e;
  height: 80px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 10px;
  gap: 20px;
  color: #fff;
  margin-top: 0.9em;
}

.employees-list-body {
  flex-grow: 1;
  padding: 15px;
  overflow-y: auto;
  color: #fff;
}

.header {
  width: 100%;
  height: 60px;
  background-color: #333;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 0.1px solid #bcbcbc;
}

.title-container {
  margin-left: 20px;
}

.button_container {
  margin-right: 20px;
}

.title-container h3 {
  color: #fff;
}

.header-row b-col {
  text-align: center;
}

.employee-row {
  padding-left: 20px;
}

.employee-details {
  color: white;
  padding-right: 20px;
}
</style>
<style>
.table thead th {
  color: #fff;
}

#employee-card {
  background-color: #2f2f2f;
  color: #fff;
  border: none;
}
</style>